import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '../common/dialog'
import { Pocket } from '../../utils/dexie/db'
import { MenuItem, TextField } from '@mui/material'
import { textFieldWhiteBg } from '../../theme/custom-styles'

export const DeletePocketModal = ({
  isLoading,
  selectedPocketId,
  currentPocketsData,
  handleDeletePocket,
  handleOpenStateOfModal
}: {
  isLoading: boolean
  selectedPocketId: string
  currentPocketsData: Array<Pocket>
  handleOpenStateOfModal: (openState: boolean) => void
  handleDeletePocket: (pocketId: string, pocketToTransferId: string) => void
}) => {
  const { t } = useTranslation(['pockets-management'])

  const [errors, setErrors] = useState<{ pocketId: string } | null>(null)
  const [pocketToTransferId, setPocketToTransferId] = useState<string>('')
  const [pocketsToSelect, setPocketsToSelect] = useState<Array<Pocket>>([])
  const [selectedPocketToDelete, setSelectedPocketToDelete] = useState<Pocket | null>(null)

  useEffect(() => {
    setSelectedPocketToDelete(currentPocketsData.find((pocketData: Pocket) => String(pocketData.id) === String(selectedPocketId)) as Pocket)
    setPocketsToSelect(currentPocketsData.filter((pocketData: Pocket) => String(pocketData.id) !== String(selectedPocketId)) as Array<Pocket>)
  }, [selectedPocketId, currentPocketsData])

  const handleSubmitPocketDataDeletion = () => {
    if (isLoading) return

    setErrors(null)

    if (!pocketToTransferId) {
      setErrors({ pocketId: t('deletePocketModal.errors.pocketTransfer') })
      return
    }

    handleDeletePocket(selectedPocketId, pocketToTransferId)
  }

  return (
    <Dialog
      actionButtonWarningStyle
      dialogIsLoading={isLoading}
      dialogTitle={t('deletePocketModal.title')}
      handleDialogAction={handleSubmitPocketDataDeletion}
      actionButtonText={t('deletePocketModal.actionButtonText')}
      handleDialogOpenState={(openState: boolean) => {
        if (isLoading) return

        handleOpenStateOfModal(openState)

        if (openState === false) {
          setSelectedPocketToDelete(null)
        }
      }}
    >
      <div
        className="company-customer-funding-modal-main-instruction"
        style={{ textAlign: 'center', lineHeight: '150%' }}
      >{`${t('deletePocketModal.warningQuestion')} ${selectedPocketToDelete?.name}?`}</div>
      <div
        className="company-customer-funding-modal-main-instruction"
        style={{ textAlign: 'center', lineHeight: '150%' }}
      >
        {t('deletePocketModal.warningText')}
      </div>
      <TextField
        select
        fullWidth
        variant="standard"
        sx={{ ...textFieldWhiteBg, '& .MuiInputBase-root .MuiSelect-select': { height: '2.7em', boxSizing: 'border-box', padding: '12px 16px 4px' } }}
        value={pocketToTransferId || ''}
        error={!!errors?.pocketId}
        helperText={errors?.pocketId}
        label={t('deletePocketModal.selectLabel')}
        onChange={(event) => setPocketToTransferId(event.target.value)}
      >
        <MenuItem
          disabled
          value=""
        >
          {t('deletePocketModal.select')}
        </MenuItem>
        {pocketsToSelect.map((pocketData: Pocket, index: number) => {
          return (
            <MenuItem
              key={index}
              value={String(pocketData.id)}
            >
              {String(pocketData.name?.toUpperCase())}
            </MenuItem>
          )
        })}
      </TextField>
    </Dialog>
  )
}
